module.exports = __webpack_public_path__ + "static/assets/7fe85d69a2626dfb865d25104f16d0ba.svg";